/* global TD */
import $ from "jquery";

function addItem(btn, ctl, baseUrl) {
	ctl = $(ctl, btn.form);
	var form = ctl[0].form, name = ctl[0].name, value = ctl.val();
	if(ctl.is("SELECT")) {
		ctl.prop("selectedIndex", 0);
	}
	else {
		ctl.val("");
		var x = ctl.next();
		if(x.is("span.ui-helper-hidden-accessible"))
			x = x.next();
		x.val("");
	}
	if(value === "")
		return;

	var vls = value.split('|');
	var key = vls[0], id = vls[1], text = vls[2];
	var keys = form.elements[name];
	if(keys && keys.tagName)
		keys = [keys];
	for(var i = 1; i < keys.length; i++) {
		var ckey = keys[i].value.split('|')[0];
		if(ckey === key)
			return;
	}
	$(btn).next().append(
		$('<li>')
		.append($('<input>', { type: 'hidden', name: name, value: value + '|1' }))
		.append($('<a>', { target: '_blank', href: baseUrl + '&id=' + id }).text(text))
		.append('\u00a0')
		.append($('<button>', { type: "button", "class": "ui-button small ui-icon-delete" })
			.text(TD.Res["form.choice.remove"])
			.on("click", function (e) { removeItem(e.target); }))
		);
}

function removeItem(btn) {
	var row = $(btn.parentNode);
	var name = row.find(">input[type=hidden]").attr("name");
	var primary = name && btn.form.querySelector('input[name="' + name + '"],select[name="' + name + '"]');
	row.remove();
	if(primary)
		$(primary).trigger("change");
}

export { addItem, removeItem };
